import { Navigate, lazyRouteComponent } from 'src/lib/routing';

import { NotFound } from 'components/NotFound/NotFound';

import type { RouteObject } from 'src/lib/routing';

// All lazy components import the same `./streams-app` module, so the whole
// Streams subtree is emitted as a single chunk and only loaded when a user
// navigates into `/streams/*` (the route is conditionally mounted in routes.tsx
// for the industry_streams_ui cohort). The route *structure* below stays eager
// so deep links like `/streams/chat/:chatId` match on a cold refresh.
const StreamsContainer = lazyRouteComponent(() => import('./streams-app'), 'StreamsContainer');
const AskContainer = lazyRouteComponent(() => import('./streams-app'), 'AskContainer');
const StreamsChatContainer = lazyRouteComponent(() => import('./streams-app'), 'StreamsChatContainer');
const StreamsChatConversationContainer = lazyRouteComponent(
  () => import('./streams-app'),
  'StreamsChatConversationContainer',
);
const StreamsChatLandingContainer = lazyRouteComponent(() => import('./streams-app'), 'StreamsChatLandingContainer');
const StreamsChatHistoryContainer = lazyRouteComponent(() => import('./streams-app'), 'StreamsChatHistoryContainer');
const DocsContainer = lazyRouteComponent(() => import('./streams-app'), 'DocsContainer');
const HighlightsContainer = lazyRouteComponent(() => import('./streams-app'), 'HighlightsContainer');
const AccountContainer = lazyRouteComponent(() => import('./streams-app'), 'AccountContainer');
const MembersContainer = lazyRouteComponent(() => import('./streams-app'), 'MembersContainer');
const SourcesContainer = lazyRouteComponent(() => import('./streams-app'), 'SourcesContainer');

/**
 * The Streams route subtree, relative to the `streams` route it's mounted under
 * in routes.tsx. Mirrors the previous `<Routes>` tree one-for-one.
 */
export const streamsRoutes: RouteObject[] = [
  {
    element: <StreamsContainer />,
    children: [
      { index: true, element: <Navigate to="chat" replace /> },
      {
        path: 'chat',
        element: <StreamsChatContainer />,
        children: [
          { index: true, element: <StreamsChatLandingContainer /> },
          { path: ':chatId', element: <StreamsChatConversationContainer /> },
        ],
      },
      { path: 'history', element: <StreamsChatHistoryContainer /> },
      {
        path: 'ask',
        children: [
          { index: true, element: <AskContainer /> },
          { path: ':chatId', element: <AskContainer /> },
        ],
      },
      {
        path: 'docs',
        children: [
          { index: true, element: <DocsContainer /> },
          { path: ':docId', element: <DocsContainer /> },
        ],
      },
      {
        path: 'sources',
        children: [
          { index: true, element: <SourcesContainer /> },
          { path: ':sourceId', element: <SourcesContainer /> },
        ],
      },
      { path: 'highlights/:evidenceId', element: <HighlightsContainer /> },
      {
        path: 'settings',
        children: [
          { path: 'account', element: <AccountContainer /> },
          { path: 'members', element: <MembersContainer /> },
        ],
      },
      { path: '*', element: <NotFound /> },
    ],
  },
];
